import React from "react";
import { useSelector } from "react-redux";
import LeaveList from "../../molecules/LeaveList/LeaveList";
import LeaveRequestStats from "../../molecules/LeaveRequestStats/LeaveRequestStats";
import AddButton from "../../atoms/AddButton/AddButton";
import { checkPermission, permissionType } from "../../../app/utils/common/Functions";
import "./LeavePage.scss";

const LeavePage = ({ openLeaveDrawer, openWorkFromHomeDrawer, onEditLeaveRequest }) => {
  const { statusCounts, loading } = useSelector((state) => state.leave);
  const canApplyLeave = checkPermission(permissionType.LEAVE_REQUEST, "create");
  const canRequestWfh = checkPermission(permissionType.WFH_REQUESTS, "create");
  const showHeroActions = canApplyLeave || canRequestWfh;

  return (
    <div className="leave-management-page leave-request-page">
      <header className="leave-management-page__hero">
        <div className="leave-management-page__hero-main">
          <h1 className="page-title">Leave Request</h1>
          <p className="page-subtitle">Track leave requests, balances, and status in one place.</p>
        </div>
        {showHeroActions ? (
          <div className="leave-management-page__hero-actions">
            {canApplyLeave ? (
              <AddButton
                buttonTitle="Apply Leave"
                image="/svg/PlusIcon.svg"
                onclickDrawer={() =>
                  typeof openLeaveDrawer === "function" ? openLeaveDrawer() : undefined
                }
              />
            ) : null}
            {/* {canRequestWfh ? (
              <AddButton
                buttonTitle="Request WFH"
                image="/svg/leave.svg"
                onClick={() =>
                  typeof openWorkFromHomeDrawer === "function"
                    ? openWorkFromHomeDrawer()
                    : undefined
                }
              />
            ) : null} */}
          </div>
        ) : null}
      </header>

      <LeaveRequestStats statusCounts={statusCounts} loading={loading} />

      <LeaveList onEditLeave={onEditLeaveRequest} />
    </div>
  );
};

export default LeavePage;
